export default __webpack_public_path__ + "f0c421ca2f85e88e5cccaa23aaf64e28.png";